import { AxiosResponse } from 'axios';
import { useMutation, useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import {
  RemoveQsrDeptXrefRequest,
  QsrDeptMaster,
  QsrDeptXref,
  CreateQsrDeptXrefRequest,
  ModifyXrefsDepartmentRequest,
} from './qsrDept.types';

export const useQsrDeptMaster = (enabled: boolean = false) => {
  return useQuery<AxiosResponse<QsrDeptMaster[]>>({
    queryKey: 'qsr-dept-master',
    queryFn: () => apiClient.get<QsrDeptMaster[]>('/qsr-dept-master'),
    enabled,
    cacheTime: 0
  });
};

export const useAddQsrDeptMaster = () => {
  return useMutation<AxiosResponse<QsrDeptMaster>, unknown, QsrDeptMaster>((requestBody: QsrDeptMaster) => {
    return apiClient.post(`/qsr-dept-master`, requestBody);
  });
};

export const useUpdateQsrDeptMaster = () => {
  return useMutation<AxiosResponse<QsrDeptMaster>, unknown, QsrDeptMaster>((requestBody: QsrDeptMaster) => {
    return apiClient.put(`/qsr-dept-master`, requestBody);
  });
};

export const useRemoveQsrDeptMaster = () => {
  return useMutation((deptId: number) => {
    return apiClient.delete(`/qsr-dept-master/${deptId}`);
  });
};

export const useQsrDeptXref = (requestBody: { deptId: number | null }, enabled: boolean = false) => {
  return useQuery<AxiosResponse<QsrDeptXref[]>>({
    queryKey: ['qsr-dept-xref', requestBody.deptId],
    queryFn: () => apiClient.get<QsrDeptXref[]>('/qsr-dept-xref', { params: requestBody }),
    enabled,
  });
};

export const useAddQsrDeptXref = () => {
  return useMutation((requestBody: CreateQsrDeptXrefRequest) => {
    return apiClient.post(`/qsr-dept-xref`, requestBody);
  });
};

export const useModifyXrefsDepartment = () => {
  return useMutation((requestBody: ModifyXrefsDepartmentRequest) => {
    return apiClient.put(`/qsr-dept-xref/modify-department`, requestBody);
  });
};

export const useRemoveQsrDeptXref = () => {
  return useMutation((requestBody: RemoveQsrDeptXrefRequest) => {
    return apiClient.delete(`/qsr-dept-xref`, { data: requestBody });
  });
};